import { addDays } from "date-fns/addDays";

export const getDates = (start: Date, n: number = 7): Date[] => {
  const dates = [];
  for (let i = 0; i < n; i++) {
    const date = addDays(start, i);
    dates.push(date);
  }
  return dates;
};
